// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginAdminDesktop_container__2Pe_C","fieldsetTitle":"LoginAdminDesktop_fieldsetTitle__3CymX"};